import * as angular from 'angular';
import {
    AccountsService,
    NotesService,
    IAccount,
    INote,
    ILocation,
    TeamService,
} from '../../../services';

class AccountsItemController {

    private accountEmployees: any;
    private account: IAccount;
    private accountsService: any;

    private notesService: any;
    private currentNote: any;
    private notes: INote[];
    private filteredNotes: INote[];
    private tags: string[];
    private selectedTag: string;

    private locations: ILocation[];

    private isNew: boolean;
    private sweetAlert: any;
    private activeTabIndex: number;

    private currentReminderInterval: any;
    private reminderIntervals: any;

    constructor(
        private AccountsService: AccountsService,
        private NotesService: NotesService,
        private TeamService: TeamService,
        private $state: ng.ui.IStateService,
        private $stateParams: ng.ui.IStateParamsService,
        private MasterdataService: aboMasterdata.IService,
        private SweetAlert: any,
        private $filter: any,
    ) {
        'ngInject';
        // console.log('AccountsItemController');

        this.accountsService = AccountsService;
        this.notesService = NotesService;

        this.sweetAlert = SweetAlert;
    }

    $onInit = () => {
        this.activeTabIndex = 0;
        if(this.$stateParams['tab']){
            this.activeTabIndex = this.$stateParams['tab'];
        }

        if (!this.account) {
            this.account = new IAccount();
            this.isNew = true;
            (<any>$('#accountBasicInfoModal')).modal('show');
        } else {
            
        }

        this.locations.forEach(location => {
            this.TeamService.customAll('location/' + location.id).then((result) => {
                location.teams = result;
                // console.log(result);
            });
        });

        this.reminderIntervals = this.reminderIntervals.reminderIntervals;
        this.reminderIntervals.forEach((item, index) => {
            item.index = index;
        });

        this.MasterdataService.getItems('NoteTags').then(res => {
            this.tags = res;
        });

        this.filterNotes();
    }

    filterNotes() {
        this.filteredNotes = this.$filter('filter')(this.notes, (note: INote): boolean => {
            if (!!this.selectedTag) {
                return note.tags.indexOf(this.selectedTag) !== -1;
            } else {
                return true;
            }
        });
    }

    submitAccount() {
        // console.log('update account');
        if (this.account.id == null) {
            if (this.account.name == null) {
                this.sweetAlert.swal('Please fill in the account name and save in order to create the account.');
            } else {
                this.saveAccount();
            }
        } else {
            this.accountsService.put(this.account.id, this.account);
        }
    }

    saveAccount() {
        this.accountsService.post(this.account).then(result => {
            this.$state.go('crm.accounts.item', { 'id': result.id });
        });
    }

    deleteAccount() {
        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u '+ this.account.name +' wilt verwijderen?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2ECC71',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, (isConfirm) => {
            if (isConfirm) {
                this.accountsService.delete(this.account.id).then(() => {
                    this.$state.go('^.list').then(() => { this.$state.reload(); });
                });
            } else {

            }
        });        
    }

    editAccountBasicInfoModal() {
        (<any>$('#accountBasicInfoModal')).modal('show');
    }

    editContactInfoModal() {
        (<any>$('#contactInfoModal')).modal('show');
    }

    editFinancialInfoModal() {
        (<any>this.account).deliveryDay = new Date(Date.parse((<any>this.account).deliveryDay));

        (<any>$('#financialInfoModal')).modal('show');
    }

    updateNote(item, action) {
        switch (action) {
            case 'add':
                this.addNoteModal();
                break;
            case 'edit':
                this.updateNoteModal(item);
                break;
            case 'delete':
                this.deleteNote(item);
                break;
        }
    }

    addNoteModal() {
        this.currentNote = null;
        (<any>$('#noteModal')).modal('show');
    }

    updateNoteModal(item) {
        this.currentNote = item;
        (<any>$('#noteModal')).modal('show');
    }

    submitNote(item) {
        var newNote = item;
        newNote.date = new Date(Date.now());
        newNote.accountId = this.account.id;

        if (newNote.id == null) {
            this.notesService.post(newNote).then(result => {
                this.notes.push(result);
            });
        } else {
            this.notesService.put(newNote.id, newNote);
        }

        (<any>$('#noteModal')).modal('hide');
    }

    deleteNote(item) {
        this.notes = this.notes.filter(note => note.id !== item.id);

        this.notesService.delete(item.id);
    }
    
    goBack() {
        window.history.go(-1);
    }

    public openProject = (item, action) => {
        this.$state.go('project.item', {'id': item.id})
    }

    submitReminderInterval(reminderInterval) {
        var itemToEdit = this.reminderIntervals.find(i => i.index === reminderInterval.index);
        if (!!itemToEdit) {
            itemToEdit = reminderInterval;
        } else {
            reminderInterval.index = this.reminderIntervals.length;
            this.reminderIntervals.push(reminderInterval);
        }
        this.accountsService.customPut(this.account.id + '/nomatchfoundemailsettings', { reminderIntervals: this.reminderIntervals }).then(result => {
            this.currentReminderInterval = null;
        });
    }

    deleteReminderInterval(reminderInterval) {
        this.reminderIntervals = this.reminderIntervals.filter(i => i.index !== reminderInterval.index);
        this.accountsService.customPut(this.account.id + '/nomatchfoundemailsettings', { reminderIntervals: this.reminderIntervals }).then(result => {
        })
    }
}

export const accountsItemComponent = {
    bindings: {
        account: '<',
        contacts: '<',
        notes: '<',
        locations: '<',
        agreements: '<',
        accountEmployees: '<',
        reminderIntervals: '<'
    },
    controller: AccountsItemController,
    template: require('./accounts.item.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/crm/accounts/accounts.item.component.ts